import { SensorStatus } from "../enums/Sensor";

export const formatSensorStatusLabel = (status: SensorStatus): string => {
  switch (status) {
    case SensorStatus.Unassigned:
      return "Unassigned";
    case SensorStatus.InWarehouse:
      return "In warehouse";
    case SensorStatus.ShippedToCustomer:
      return "Shipped to customer";
    case SensorStatus.AtCustomer:
      return "At customer";
    case SensorStatus.AssignedInternal:
      return "Assigned Internal";
    case SensorStatus.AssignedRemote:
      return "Assigned for Remote";
    case SensorStatus.AssignedToClinic:
      return "Account On-site Inventory";
    case SensorStatus.AssignedForInClinic:
      return "Assigned for In Clinic";
    case SensorStatus.Damaged:
      return "Damaged";
    case SensorStatus.ReturnedToWarehouse:
      return "Returned to Warehouse";
    case SensorStatus.Lost:
      return "Lost";
    default:
      return "-";
  }
};
